import MuiButton from './MuiButton';
import MuiInput from './MuiInput';
import MuiInputLabel from './MuiInputLabel';
import MuiSelect from './MuiSelect';

export default {
  MuiButton,
  MuiInput,
  MuiInputLabel,
  MuiSelect,
};
